/**
 * Step 15 — Reminder picker
 *
 * Spec: specs/onboarding-rebuild.md → Act 3 step 15
 *
 * Variant scaffolding retired 2026-05-14 — synthesis is production.
 */

import ReminderPickerSynthesis from './ReminderPicker.synthesis'

export const TIME_OPTIONS = [
  { value: 5, label: '5 min' },
  { value: 10, label: '10 min' },
  { value: 15, label: '15 min' },
  { value: 30, label: '30 min' },
]

// 2026-05-18 — 'email' / 'push' / 'browser' dropped. The synthesis component
// is now a binary Yes/No toggle that writes 'notifications' (for Yes) or
// 'none' (for No). Kept exported for callers that import this constant for
// validation; consumers should treat any non-'notifications' / non-'none'
// value as legacy and prompt the user to re-pick.
export const REMINDER_OPTIONS = [
  { value: 'none', label: 'No reminders' },
  { value: 'notifications', label: 'Daily nudge' },
]

export default function ReminderPickerStep({
  timeGoal,
  reminderMethod,
  onTimeChange,
  onMethodChange,
  onContinue,
}) {
  return (
    <ReminderPickerSynthesis
      timeGoal={timeGoal}
      reminderMethod={reminderMethod}
      onTimeChange={onTimeChange}
      onMethodChange={onMethodChange}
      onContinue={onContinue}
      timeOptions={TIME_OPTIONS}
      reminderOptions={REMINDER_OPTIONS}
    />
  )
}
